import {useImoveisStore} from '../context/DataContext'
import MapView from '../partials/Map'

interface MapVendaProps {
  height: number
}

const MapAluguel = ({height}: MapVendaProps) => {
  const {imoveis} = useImoveisStore()
  return (
    <>
      <MapView height={height} imoveis={imoveis} finalidade={'aluguel'}></MapView>
    </>
  )
}

export default MapAluguel
